import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex items-center gap-2">
      <Globe className="w-4 h-4 text-gray-500" />
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="appearance-none bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full px-4 py-2 text-sm font-medium text-gray-700 
        hover:bg-gray-50 hover:border-gray-300 
        focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500
        transition-all duration-200 ease-in-out
        cursor-pointer
        shadow-sm"
      >
        <option value="en" className="text-gray-700 bg-white">{t('language.en')}</option>
        <option value="es-MX" className="text-gray-700 bg-white">{t('language.es-MX')}</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher; 